import React from 'react'

function Credit_Dette() {
  return (
    <div>Credit Dette</div>
  )
}

export default Credit_Dette